
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/business/accommodation",
      function () {
        return require("private-next-pages/business/accommodation/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/business/accommodation"])
      });
    }
  